var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.user.organizeId == '1539222979880206338')?_c('div',{staticClass:"BdVisualScreen"},[_c('svg-icon',{staticClass:"screen_icon",attrs:{"icon-class":"visualScreen"},on:{"click":_vm.visualScreenRoute}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }